import { REGISTER_ROUTE_SERVICE } from "../entities/ShopAuthority"

export const isShopify = (shop) => {
  return shop?.service == REGISTER_ROUTE_SERVICE.Shopify
}

export const isWeb = (authority) => {
  return authority?.service == REGISTER_ROUTE_SERVICE.Web
}

export const isValidCharacterSubdomain = (subdomain: string) => {
  const regex = new RegExp('[^(a-z)(0-9)-]');``
  return !regex.test(subdomain)
}